import View from "./View";

const List = () => {
  return (
    <View />
  );
};

export default List;
